import { render, staticRenderFns } from "./vendorNewEditAgreement.vue?vue&type=template&id=2d8bb88e&"
import script from "./vendorNewEditAgreement.vue?vue&type=script&lang=js&"
export * from "./vendorNewEditAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports